import {
  EmploymentControllerDTO,
  EmploymentNotification,
  PaginationModel,
  User,
} from '@builddocs/data-management'
import axios, { AxiosResponse } from 'axios'

export const BAPIBAPIBEEPBEEPv2 = axios.create({
  baseURL: '/api',
})
export const BAPIBAPIBEEPBEEPv2_EMPTY = axios.create({
  baseURL: '',
})
export const loginUserHardcoded = (creds: {
  username: string
  password: string
}): Promise<AxiosResponse<{ jwtToken: string; refreshToken: string }>> => {
  return BAPIBAPIBEEPBEEPv2.post('/login', creds)
}

export const getUserHardcoded = (
  jwtToken: string,
): Promise<AxiosResponse<User>> => {
  return BAPIBAPIBEEPBEEPv2.get('/users/current', {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  })
}

export const getPositionHardcoded = (
  adminJwtToken: string,
): Promise<
  AxiosResponse<
    {
      createDateTime: string | null
      description: string
      inn: string
      positionId: string
      value: string | null
    }[]
  >
> => {
  return BAPIBAPIBEEPBEEPv2.get('/position', {
    headers: {
      Authorization: `Bearer ${adminJwtToken}`,
    },
  })
}

export const createPositionHardcoded = (
  newPositionName: string,
  adminJwtToken: string,
): Promise<
  AxiosResponse<{
    createDateTime: string | null
    description: string
    inn: string
    positionId: string
    value: string | null
  }>
> => {
  return BAPIBAPIBEEPBEEPv2.post(
    `/position`,
    {},
    {
      params: { description: newPositionName },
      headers: {
        Authorization: `Bearer ${adminJwtToken}`,
      },
    },
  )
}

export const getEmploymentsHireHardcoded = async (
  jwtToken: string,
): Promise<PaginationModel<EmploymentNotification>> =>
  BAPIBAPIBEEPBEEPv2_EMPTY.get(`/camunda/api/v1/employment/notifications`, {
    params: { pageNumber: 0, pageSize: 1 },
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  }).then(response => response.data)

export const responseHireInvitationHardcoded = async (
  jwtToken: string,
  employment: EmploymentControllerDTO,
) =>
  BAPIBAPIBEEPBEEPv2.post(`/users/offer-response/ACCEPTED`, employment, {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  })

export const createEmploymentInviteHardcoded = (
  userId: string,
  employmentOrder: string,
  employmentOrderDate: string,
  position: {
    description: string | null
    inn: string | null
    positionId: string
  },
  adminJwtToken: string,
): Promise<
  AxiosResponse<{
    createDateTime: string | null
    description: string
    inn: string
    positionId: string
    value: string | null
  }>
> => {
  const configuredData = { employmentOrder, employmentOrderDate, position }

  return BAPIBAPIBEEPBEEPv2.post(`/users/hire/${userId}`, configuredData, {
    headers: {
      Authorization: `Bearer ${adminJwtToken}`,
    },
  })
}
